module.exports = __webpack_public_path__ + "img/terracenew_box24.e823f398.jpg";